"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceOceanTile = void 0;
const SelectSpace_1 = require("../inputs/SelectSpace");
const SpaceType_1 = require("../SpaceType");
const DeferredAction_1 = require("./DeferredAction");
const TileType_1 = require("../TileType");
class PlaceOceanTile {
    constructor(player, title = 'Select space for ocean tile', playerToGainPlacementRewards = player) {
        this.player = player;
        this.title = title;
        this.playerToGainPlacementRewards = playerToGainPlacementRewards;
        this.priority = DeferredAction_1.Priority.PLACE_OCEAN_TILE;
    }
    execute() {
        if (this.player.game.noOceansAvailable()) {
            return undefined;
        }
        return new SelectSpace_1.SelectSpace(this.title, this.player.game.board.getAvailableSpacesForOcean(this.player), TileType_1.TileType.OCEAN, (space) => {
            this.player.game.addOceanTile(this.player, space.id, SpaceType_1.SpaceType.OCEAN, this.playerToGainPlacementRewards);
            return undefined;
        });
    }
}
exports.PlaceOceanTile = PlaceOceanTile;
//# sourceMappingURL=PlaceOceanTile.js.map